/*
 * @Description:
 * @Author: cooky
 * @Date: 2021-02-25 17:17:51
 * @LastEditors: cooky
 * @LastEditTime: 2021-03-16 15:56:59
 */
export default [
  {
    label: 'CN',
    value: 'zh_cn'
  },
  {
    label: 'EN',
    value: 'en_us'
  },
  {
    label: 'TC',
    value: 'zh_tw'
  }
]
